import type { CommonCaseTask } from 'models';

import useTranslation from 'shared/hooks/useTranslation';

import {
  Card,
  CardContainer,
  CardTitle,
  Item,
  Label,
  List,
  Value,
} from 'shared/components/styled/Cases';

import { PmCompanyName } from './TaskInfo.styled';

type TasksInfoProps = {
  tasks: CommonCaseTask[];
};

const TasksInfo = ({ tasks }: TasksInfoProps) => {
  const { t } = useTranslation();

  return (
    <CardContainer>
      <CardTitle>{t('#portal.incident.task.common.header')}</CardTitle>
      <Card>
        <List>
          {tasks.map((task, idx) => (
            <Item direction="column" key={idx} spacing={0}>
              <Item>
                <Label>{task.Executor?.Name}</Label>
                <Value>{task.StatusInfo ?? task.Status?.Label}</Value>
              </Item>
              {task.PMCompany?.Name && (
                <Item>
                  <PmCompanyName>{task.PMCompany.Name}</PmCompanyName>
                </Item>
              )}
              {task.IsAutomaticallyManaged && (
                <Item>
                  <Label>
                    {t('#portal.incident.task.common.automaticallymanaged')}
                  </Label>
                </Item>
              )}
            </Item>
          ))}
        </List>
      </Card>
    </CardContainer>
  );
};

export default TasksInfo;
